import React, { Fragment } from 'react';
import TextField from '@material-ui/core/TextField';

import { Invalid } from '../feedbacks';

const Hidden = ({name, type, label, helpText, errors, value, onChange}) => {
  const data = { errors };
  return <Fragment >
    <TextField
      className="hidden"
      fullWidth
      id={name}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      helperText={helpText}
      variant="outlined"
      margin="dense"
    />
  </Fragment>
}

export default Hidden;
